/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { useParams } from 'react-router-dom'
import { useLocation } from "react-router";
import EditESPTabs from './EditESPTabs';

const EditESP: React.FC = () => {

  const param = useParams();
  const data: any = useLocation();
  const {id} = param;
  return (   
        <EditESPTabs espId={id} espData={data.state.espData} />
  )
}

export default EditESP